export default [{
  path: '/classify/product',
  name: 'product',
  meta: {
    index: 25
  },
  component: () => import('@/views/product/index.vue')
}]
